import React from "react";
import { Modal } from "@sumprio/ui";
import ModalPortalRoot from "./ModalPortalRoot";

interface SidebarActionModalProps {
  open: boolean;
  title: string;
  primaryLabel: string;
  primaryDisabled?: boolean;
  sideSize?: "sm" | "md";
  onClose: () => void;
  onConfirm: () => void;
  children: React.ReactNode;
}

export default function SidebarActionModal({
  open,
  title,
  primaryLabel,
  primaryDisabled = false,
  sideSize = "md",
  onClose,
  onConfirm,
  children,
}: SidebarActionModalProps) {
  return (
    <ModalPortalRoot open={open} variant="side">
      <Modal
        variant="side"
        open={open}
        onClose={onClose}
        closeOnBackdropClick={false}
        closeOnEscape={false}
        title={title}
        showCloseButton
        showSecondaryButton
        showCancelButton={false}
        secondaryLabel="Cancel"
        onSecondary={onClose}
        showPrimaryButton="primary"
        primaryLabel={primaryLabel}
        primaryDisabled={primaryDisabled}
        onPrimary={onConfirm}
        primaryButtonProps={{ size: "xs" }}
        showFooterDivider
        showHeaderDivider
        sideSize={sideSize}
        secondaryButtonProps={{ variant: "brand-secondaryGrey", size: "xs" }}
      >
        {children}
      </Modal>
    </ModalPortalRoot>
  );
}
